var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccountIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.39 113.39",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #1d1d1b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 8.5px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.16,109.18c0-22.88,23.1-41.42,51.58-41.42s51.58,18.54,51.58,41.42H5.16ZM56.74,4.33c-10.64,0-19.26,12.64-19.26,28.23s8.62,28.23,19.26,28.23,19.26-12.64,19.26-28.23-8.62-28.23-19.26-28.23Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccountIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "account-icon.c633ad7cccd4c72a2e2308d618205825.svg";